import { MouseEvent, useEffect, useState } from 'react'
import { Typography, Card, Stack, Button } from '@mui/material'
import { GroupRoundedIcon } from '../../../../icons/GroupRoundedIcon'
import { PersonRoundedIcon } from '../../../../icons/PersonRoundedIcon'
import {
  TypTitle,
  TypCity,
  TypDescription,
  CounterLabel,
  CounterIcon,
} from './style'
import { formatNumber } from '../../../../common/FormatNumber'
import { ViewCounter } from '../../../ui-kit/ViewCounter'
import { useNavigate } from 'react-router-dom'
import { routesProfile } from '../../../../consts'
import type { TeamDescription } from '../../../../types/entitys/teams'
import { profileApi } from '../../../../api/profile'
import { TeamSubscribeButton } from '../../TeamSubscribeButton'
import { UserAvatar } from '../../../common/UserAvatar'

type TeamProps = {
  team: TeamDescription
}

export const MobileCard = ({ team }: TeamProps) => {
  const navigate = useNavigate()
  const { data: me } = profileApi.useGetProfileQuery()
  const isAuthor = me?.id !== undefined && me.id === team.authorId
  const [subscribersCount, setSubscribersCount] = useState(Number(team.subscribers ?? 0))

  useEffect(() => {
    setSubscribersCount(Number(team.subscribers ?? 0))
  }, [team.id, team.subscribers])
  const navigateToTeam = () => {
    navigate(`/${routesProfile.TEAMS.path}/${team.slug || team.id}`)
  }
  const handleEdit = (e: MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation()
    navigate(`/${routesProfile.TEAMS.path}/${team.id}/edit`)
  }
  const handleStopPropagation = (e: MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation()
  }

  return (
    <Card variant="primaryAdaptiveCard" onClick={navigateToTeam} sx={{ overflow: 'visible' }}>
      <Stack direction="column" width="100%">
        <Stack direction="row" justifyContent="space-between" alignItems="center" pt={1.5}>
          <Typography variant="h3" sx={TypTitle} noWrap>
            {team.title}
          </Typography>
          {isAuthor ? (
            <Button variant="follow" sx={{ ml: 1 }} onClick={handleEdit}>
              Редактировать
            </Button>
          ) : (
            <TeamSubscribeButton
              teamId={team.id}
              isSubscribed={team.isSubscribed}
              onClick={handleStopPropagation}
              onSubscriptionChange={(wasSubscribed) => {
                setSubscribersCount((n) => Math.max(0, n + (wasSubscribed ? -1 : 1)))
              }}
            />
          )}
        </Stack>
        <Typography variant="h4" sx={TypCity} noWrap>
          {team.city}
        </Typography>
        <Stack direction="row" gap={2} alignItems="flex-start" pt={1} pb={1}>
          <UserAvatar src={team.image} size={90} />
          <Stack minWidth={0} flex={1}>
            <Typography variant="body1" sx={TypDescription}>
              {team.descriptionFull}
            </Typography>
          </Stack>
        </Stack>
        <Stack direction="column" pb={1.5} gap={1}>
          <Stack direction="row" justifyContent="space-between">
            <Stack direction="row" gap={1.5} alignItems="center">
              <Stack direction="row" alignItems="center" spacing={0.5}>
                <PersonRoundedIcon fontSize="small" sx={CounterIcon} />
                <Typography variant="black-14-medium" sx={CounterLabel}>Участников:</Typography>
                <Typography variant="black-14-medium">{formatNumber(team.participants)}</Typography>
              </Stack>
              <Stack direction="row" alignItems="center" spacing={0.5}>
                <GroupRoundedIcon fontSize="small" sx={CounterIcon} />
                <Typography variant="black-14-medium" sx={CounterLabel}>Подписчиков:</Typography>
                <Typography variant="black-14-medium">{formatNumber(subscribersCount)}</Typography>
              </Stack>
            </Stack>
            <ViewCounter count={team.views} />
          </Stack>
        </Stack>
      </Stack>
    </Card>
  )
}
